module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isNumber.js
// module id = 1564
// module chunks = 0